export const gMapsApiKey = 'AIzaSyAYCbn17RqoFl6DLVGF0HQK_4cJGgCvFrU';
